export default __webpack_public_path__ + "static/media/info-circle.e8dd9e88.svg";